exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=file][data-v-19b7d2ca]{cursor:pointer!important;font:300 14px sans-serif;color:#9e9e9e}input[type=file][data-v-19b7d2ca]::-webkit-file-upload-button{font:300 14px sans-serif;background:#009688;border:0;padding:12px 25px;cursor:pointer;color:#fff;text-transform:uppercase}input[type=file][data-v-19b7d2ca]::-ms-browse{font:300 14px Roboto,sans-serif;background:#009688;border:0;padding:12px 25px;cursor:pointer;color:#fff;text-transform:uppercase}", ""]);

// exports
